import request from '@/utils/request'
import { parseImageUrl } from '@/utils/imageUtils'

/**
 * 获取功能专区广告列表
 * @param {string} advertcode - 广告代码
 * @param {number} pageindex - 页码
 * @param {number} pagesize - 每页数量
 * @param {string} kind - 类型
 * @returns {Promise} 返回处理后的广告数据列表
 */
export async function getFeatureZoneList(advertcode, pageindex, pagesize, kind) {
  try {
    const response = await request({
      url: '/api/Advert/LoadAdvertList',
      method: 'post',
      data: {
        AdvertCode: advertcode,
        PageIndex: pageindex || 1,
        PageSize: pagesize || 10,
        Kind: kind || 'PRODUCT'
      }
    })

    // 保持与其他 API 相同的返回结构
    return {
      ErrorCode: response.ErrorCode,
      ErrorMessage: response.ErrorMessage,
      Data: {
        List: response.Data ? response.Data.map(item => ({
          id: item.ProductNo,
          name: item.Title,                    // Title 对应 ProductName
          description: item.Describe,          // Describe 对应 ShortDesc
          imageUrl: parseImageUrl(item.ImageUrl),
          price: parseFloat(item.Param1) || 0, // Param1 对应 SalePrice
          originalPrice: parseFloat(item.Param2) || 0, // Param2 对应 MarketPrice
          url: item.Url,
          status: item.Param3,
          storage: null,
          saleCount: 0,
          isLike: 0,
          favoriteCount: 0
        })) : [],
        Total: response.Data ? response.Data.length : 0
      }
    }
  } catch (error) {
    console.error('获取功能专区数据失败:', error)
    throw error
  }
} 